import 'apps/admin/styles/admin.scss';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import RequiresAuth from 'util/hoc/requires-auth';
import WithConfig from 'util/hoc/with-config';
import AppHeader from 'components/header';
import { ShimmyValue } from 'library/components/shimmy';
import { resolve } from 'library/helpers/path-resolver';
import FourOhFourPage from 'core/pages/four-oh-four';
import DynamicPage from 'util/hoc/dynamic-page';

const Admin = DynamicPage(async () => (
  await import(/* webpackChunkName: "admin" */ 'apps/admin/app')
));

export const AppNavigation = () => (
  <span>{trans`Admin`}</span>
);

const Main = ({ configuration }) => (
  <Fragment>
    <ShimmyValue namespace="main_navigation">
      <AppHeader show={true} />
    </ShimmyValue>
    {
      resolve(configuration, 'apps/admin/allowed', false)
        ? (
          <Admin />
        )
        : <FourOhFourPage />
    }
  </Fragment>
);

Main.propTypes = {
  configuration: PropTypes.object
};

export default RequiresAuth(WithConfig(Main));
